import React, { useRef } from 'react';

import { assetUrl } from '~/helpers';
import { MessageTemplateType } from '~/types/models';
import { TemplateState } from '~/App/Modules/Settings/MessageTemplates/Pages/Editor';
import cx from 'classnames';
import { Tooltip } from '@vimily/bonjoro-ui-components-v2/Tooltip';

interface MessageTemplateIconProps {
  className?: string;
  templateState: string;
  templateType: MessageTemplateType;
}

interface IconProps {
  image: string;
  toolTip: string;
}

type Icons = Record<string, IconProps>;

export default function MessageTemplateIcon({
  className,
  templateState,
  templateType,
}: MessageTemplateIconProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  const icons: Icons = {
    demo: {
      image: 'demo-template.svg',
      toolTip: 'This is a demo template provided by Bonjoro',
    },
    postcard: {
      image: 'Message-temps.svg',
      toolTip: 'Postcard template',
    },
    nextgen: {
      image: 'nextgen-template.svg',
      toolTip: 'Next Gen template',
    },
  };

  const iconType =
    templateState === TemplateState.Demo ? TemplateState.Demo : templateType;

  const icon = icons[iconType];

  return (
    <div className={cx('flex flex-row gap-x-2', className)} ref={containerRef}>
      <Tooltip
        content={icon.toolTip}
        positions={['bottom']}
        containerRef={containerRef}
      >
        <img
          className='template-icon h-4'
          src={assetUrl(`assets/images/icons/message-template/${icon.image}`)}
        />
      </Tooltip>
    </div>
  );
}
